<div class="pi pi-times" mat-button (click)="dialogRef.close()" style="position: absolute; top: 27px; right: 45px; color: gray;"></div>
<div>
  <mat-dialog-content>
    <p-table [value]="itProfiles"
             [rows]="100"
             [paginator]="true"
             [pageLinks]="3"
             [rowsPerPageOptions]="[10, 20, 50, 100]"
             [style]="{'margin-top':'10px'}"
             selectionMode="single"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             (onRowExpand)="getDevices($event)"
             dataKey="clientITProfileId"
             #dashboardTable>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header">
          <td colspan="3">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{item.name}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-rowData let-columns="columns">
        <p-table [value]="rowData.devices"
                 #projectsTable
                 [rows]="100"
                 selectionMode="multiple"
                 dataKey="deviceId"
        >

          <ng-template pTemplate="header">
            <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
              <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col['width'] || 'auto'}">
                {{col.header}}
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-columns="columns">
            <tr
              (click)="selectDevice(item)">
              <td>{{item.deviceName}}</td>
              <td>{{item.type}}</td>
              <td>{{item.manufacturer}}</td>
            </tr>
          </ng-template>
        </p-table>

      </ng-template>
    </p-table>

  </mat-dialog-content>
</div>
